import { createFileRoute } from "@tanstack/react-router";

import { routeHead } from "@/lib/seo-head";
import MentionsLegales from "@/pages/MentionsLegales";

export const Route = createFileRoute("/mentions-legales")({
  head: () =>
    routeHead({
      path: '/mentions-legales',
      title: 'Mentions légales | JIIA Studio',
      description: "Mentions légales du site JIIA Studio, architecte d'intérieur à Lyon et dans l'Ouest lyonnais.",
    }),
  component: MentionsLegales,
});
